module.exports = __webpack_public_path__ + "fonts/effect-two-days-thirty-years-797543.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-two-days-thirty-years.svg
// module id = 844
// module chunks = 0